<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.cardName"
          placeholder="请输入储值卡名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditStatus"
          label="审核状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus === 'wait'" class="blue">
              待审核
            </div>
            <div v-if="scope.row.auditStatus === 'agree'" class="success">
              已通过
            </div>
            <div v-if="scope.row.auditStatus === 'refuse'" class="danger">
              已驳回
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardName"
          label="储值卡名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardBgp"
          label="卡样"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width:100px; height:40px"
                :src="scope.row.cardBgp"
                :preview-src-list="[scope.row.cardBgp]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="可售门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardDenomination"
          label="储值卡面额"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardDenomination }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardSalePrice"
          label="储值卡售价"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.cardSalePrice }}元</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditUsername"
          label="审核人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="审核备注"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="上架状态"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.salesState === 'down' ? 'danger' : 'success'"
            >
              {{ scope.row.salesState === "down" ? "下线" : "上线" }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          width="200"
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="toDetails(scope.row)"
                >详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-dialog
          width="30%"
          title="审核备注"
          :visible.sync="innerVisible"
          append-to-body
        >
          <el-form label-width="90px">
            <el-form-item label="审核备注：">
              <el-input
                maxlength="100"
                placeholder="请输入审核备注"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="remark"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <!-- <el-button
              @click="auditCard('agree')"
              size="small"
              type="primary"
              v-if="auditStatus === 'agree'"
              >通 过</el-button
            >
            <el-button
              @click="auditCard('refuse')"
              size="small"
              type="danger"
              v-if="auditStatus === 'refuse'"
              >驳 回</el-button
            > -->

            <el-button @click="innerVisible = false" size="small"
              >取 消</el-button
            >
          </span>
        </el-dialog>
        <ul class="info-list">
          <li class="mb20">
            <div class="title">
              基本规则
            </div>
            <div class="modal-table mb20">
              <div class="table-header flex">
                <!-- <div class="flex-1">匹配信息</div> -->
                <div class="flex-1">储值卡名称</div>
                <div class="flex-1">卡样式</div>
                <div class="flex-1">储值卡售价</div>
                <div class="flex-1">发售数量</div>
                <div class="flex-1">储值卡面值</div>
              </div>
              <div class="table-body flex item-center">
                <!-- <div class="flex-1">
                      {{}}
                    </div> -->
                <div class="flex-1">
                  {{ details.cardName }}
                </div>
                <div class="flex-1">
                  <el-image
                    style="width:100px; height:40px"
                    :src="details.cardBgp"
                    :preview-src-list="[details.cardBgp]"
                  >
                  </el-image>
                </div>
                <div class="flex-1">
                  <span class="primary"> {{ details.cardSalePrice }}元 </span>
                </div>
                <div class="flex-1">
                  {{ details.stockNum }}
                </div>
                <div class="flex-1">
                  <span class="primary">
                    {{ details.cardDenomination }}元
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li class="mb20">
            <div class="title">
              使用规则
            </div>
            <div style="margin:10px 0;color:#222">
              <div>
                使用时段:
                <span v-if="details.validMode === 'now'"
                  >即买即用,购买后{{ details.validDuration }}月过期。</span
                >
                <span v-if="details.validMode === 'range'"
                  >限时使用,{{ details.validStartTime }}至{{
                    details.validEndTime
                  }}</span
                >
              </div>
            </div>
            <div style="marginBottom:5px;color:#222">
              商品限制
            </div>
            <el-table
              stripe
              ref="brandTable"
              class="mb20 modal-table"
              :header-cell-style="{ background: ' #f7f7f7', color: '#222' }"
              :data="details.prepayGoodsList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrId"
                label="商品Id"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="attrValue"
                label="商品名称"
              ></el-table-column>
              <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="attrType"
                    label="类型"
                  ></el-table-column> -->
            </el-table>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer flex flex-center">
          <!-- <el-button
            @click="openRemark('agree')"
            size="small"
            type="primary"
            v-if="row.auditStatus === 'wait'"
            >通 过</el-button
          >
          <el-button
            @click="openRemark('refuse')"
            size="small"
            type="danger"
            v-if="row.auditStatus === 'wait'"
            >驳 回</el-button
          > -->

          <el-button @click="dialogVisible = false" size="small"
            >取 消</el-button
          >
        </span>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      remark: "",
      row: {},
      details: {},
      searchCondition: {},
      title: "",
      innerVisible: false,
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      auditStatus: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    openRemark(auditStatus) {
      this.innerVisible = true;
      this.auditStatus = auditStatus;
    },
    async auditCard(auditStatus) {
      if (auditStatus === "refuse" && this.remark === "") {
        this.$message({
          message: "请填写驳回备注！",
          type: "warning"
        });
      } else {
        let params = {
          remark: this.remark,
          auditStatus,
          cardId: this.row.cardId
        };
        const { code } = await this.$store.dispatch("editPrepayCard", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.innerVisible = false;
          this.dialogVisible = false;
          this.queryList();
          setTimeout(() => {
            this.remark = "";
          }, 0);
        }
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryPrepayCardList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    toDetails(row) {
      this.row = row;
      this.type = "details";
      this.title = "储蓄卡详情";
      this.dialogVisible = true;
      this.$store
        .dispatch("detailPrepayCard", { cardId: row.cardId })
        .then(res => {
          this.details = res.result;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 10px;
    }
  }
}
</style>
